module.exports = __webpack_public_path__ + "static/media/Contact.2bd444dd.png";